<template>
  <div>
    <div>
      <div>
        <cvt-admin-left-nav-bar
          style="top: 64px"
          usage="adminBranding"
          initial-active-id="branding"
          :mode="mode"
        >
        </cvt-admin-left-nav-bar>
      </div>
      <div style="position: absolute; left: 280px; top: 64px">
        Branding Data is displayed here
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from 'lodash'
import { mapActions, mapGetters, mapState } from 'vuex'
import * as getters from '../../store/modules/getters'
import * as actions from '../../store/modules/actions'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Branding',
  data() {
    return {
      mode: 'LIGHT',
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: getters.AUTH_GET_USER_IS_ADMIN,
      admin: getters.AUTH_GET_USER
    }),

    ...mapState('super', [
      'searching',
      'projects',
      'organizations',
      'currentOrgID',
      'currentProjectID'
    ]),
  },
  watch: {},
  created() {},
  methods: {
    ...mapActions('super', [
      'onProjectChange',
      'onOrgChange',
      'searchOrganizations',
      'searchProjects',
      'sudo'
    ]),
  },
}
</script>
<style lang="scss">
@import "@/scss/utils";
</style>
